jQuery(function($) {
    var fcwrapClass = '.wpcf7-form-control-wrap';

    function validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    function getStyleProp(elem, prop){
        if (elem.getBoundingClientRect() && (prop.indexOf('height') > -1)|| prop.indexOf('width') > -1) {
                return elem.getBoundingClientRect()[prop];
        }

        if (window.getComputedStyle)
            return window.getComputedStyle(elem, null).getPropertyValue(prop);
        else if(elem.currentStyle) return elem.currentStyle[prop]; //IE
    }

    function getDocHeight() {
        var D = document;
        return Math.max(
            D.body.scrollHeight, D.documentElement.scrollHeight,
            D.body.offsetHeight, D.documentElement.offsetHeight,
            D.body.clientHeight, D.documentElement.clientHeight
        );
    }

    var Voucher = {
        button: {
            enable: function() {
                $('.wpcf7-submit').removeClass('disabled').prop('disabled', false).closest(fcwrapClass).removeClass('disabled');
            },
            disable: function() {
                $('.wpcf7-submit').addClass('disabled').prop('disabled', true).closest(fcwrapClass).addClass('disabled');
            }
        },
        loader: {
            show: function() {
                $('.voucher-loader').fadeIn(80);
            },
            hide: function() {
                $('.voucher-loader').fadeOut(80);
            }
        },
        contact7FormEvents: function() {
            /**
             * Add this event to manipulate the error response of the form. 
             */
            document.addEventListener( 'wpcf7submit', function( event ) {
                $('.select-plugin-wrap.how_may_times_visited').find('.wpcf7-not-valid-tip').remove();
                $('.wpcf7-form-control-wrap').removeClass('form-error');

                if (event && event.detail && event.detail.apiResponse && event.detail.apiResponse.invalid_fields) {
                    event.detail.apiResponse.invalid_fields.forEach(function(v, i) {
                        $(v.into.toString()).removeClass('invalid-number');

                        if (v && v.into && v.into.toString().indexOf('how_may_times_visited') > -1) {
                            $('div.select-plugin-wrap').addClass('form-error').append('<span class="wpcf7-not-valid-tip" role="alert" aria-hidden="true">'+v.message+'</span>');
                        } else if (v && v.into && v.into.toString().indexOf('mobile_number') > -1) {
                            if (v.message.indexOf('country code') > -1) {
                                $(v.into.toString()).addClass('invalid-number');
                            }
                        }

                        $(v.into.toString()).closest('.wpcf7-form-control-wrap').addClass('form-error');
                    });
                }
                    
                setTimeout(function() {
                    var outputDiv = $('.error-message-section'),
                        errorDiv = $('.wpcf7-response-output');

                    outputDiv.html('<div class="wpcf7-response-output-div"><span><strong class="front">'+errorDiv.html()+'</strong><strong></strong><strong class="back"></strong></span></div>&nbsp;');

                    $('.agreement-section input').prop('checked', false).trigger('change');
                    Voucher.button.disable();
                }, 50);
            }, false );

            /**
             * Add this event to manipulate response of contact form 7 after the submission.
             */
            document.addEventListener( 'wpcf7mailsent', function( event ) {
                var height = $('.form-wrapper .wpcf7').height();
                var width = $('.form-wrapper .wpcf7').width();
                var name = $('[name="first_name"]').val();

                $('.hide-on-form-successs').each(function() {
                    height = height + $(this).height();
                });

                $('.form-wrapper .wpcf7,.hide-on-form-successs').remove();
                $('.form-wrapper .form-icons').addClass('display-icons-success');

                $('.form-container-hidden').css({ 'height': height+'px', 'width': width + 'px' });
                $('.thankyou-message').removeClass('d-none').addClass('d-flex').find('span').text((name||'').toUpperCase() + '!');

                ga('gtm2.send', 'event', 'promotions', 'christmas-voucher-2020', 'signup-completed', '1');

                setTimeout(function() {
                    Voucher.displayGallery();
                }, 5000);
            }, false );

            /** DOM events */
            $('.wpcf7-form-control-wrap').on('change', 'input[type="checkbox"]', function() {
                var displayEl = $(this).closest('.agreement-section').find('.check-display');

                Voucher.button.disable();

                if (this.checked) {
                    displayEl.addClass('checked');
                } else {
                    displayEl.removeClass('checked');
                }

                if ($('.wpcf7-form-control-wrap.agreement').find('input[type="checkbox"]').is(':checked')) {
                    Voucher.button.enable();
                }
            });

            $('.wpcf7-form-control-wrap').on('input', 'input', function() {
                if ($('.wpcf7-form-control-wrap.agreement').find('input[type="checkbox"]').is(':checked')) {
                    Voucher.button.enable();
                }             
            });

            $('.wpcf7-form-control-wrap').on('focus', 'input', function() {
                $(this).closest('.wpcf7-form-control-wrap.form-error').trigger('click');
            });

            $('body').on('click', '.wpcf7-form-control-wrap.form-error', function() {
                var el = $(this);

                el.find('.wpcf7-not-valid-tip').remove();
                el.removeClass('form-error');
                el.find('.wpcf7-form-control').trigger('focus');
                el.find('.wpcf7-form-control').trigger('click');
            });

            /** DOM events */
            $('body').on('click', '.wpcf7-submit', function() {
                setTimeout(function() {
                    $('.error-message-section').html('&nbsp;');
                    if (validateEmail($('[name="email_address"]').val()) || $('[name="email_address"]').val().trim() === "") {
                        Voucher.button.disable();
                    }
                }, 20);
            });

            $('body').on('click', '.show-the-form', function(e) {
                var $colVoucher = $('.col-form .first-col'),
                    $colForm = $('.col-form .second-col');

                    $colVoucher.addClass('hidden-col');
                    $colForm.addClass('display-col');

                    Voucher.screen();

                e.preventDefault();
                return false;
            });

            $('body').on('mouseover', 'img.see-more', function() {
                $(this).attr('src', $(this).data('hover'));
            });

            $('body').on('mouseout', 'img.see-more', function() {
                $(this).attr('src', $(this).data('src'));
            }); 

            $('.wpcf7-form-control').attr('autocomplete', 'off');

        },
        selectPlugin: {
            init: function() {
                $('select.wpcf7-form-control').each( function() {
                    var options = $(this).children().map(function() {
                        return this.value;
                    }).get(), list = '';
                    
                    $(this).closest('.wpcf7-form-control-wrap').addClass('invisible-layer');
        
                    options.forEach(function(i, v) {
                        if (i.toString().trim() != '') {
                            list += '<li><a href="#">'+i+'</a></li>';
                        }
                    });
        
                    $(this)
                        .closest('.wpcf7-form-control-wrap')
                        .after('<div class="wpcf7-form-control-wrap how_may_times_visited select-plugin-wrap"><div class="wpcf7-form-control select-plugin"><span class="text-purple text-label"></span><span class="indicator-arrow"></span><span class="indicator-x"></span><ul>'+list+'</ul></div></div>');
        
                    Voucher.selectPlugin.events();
                });
            },
            events: function() {
                $('.select-plugin-wrap').on('click', '.select-plugin', function() {
                    var parent = $(this).closest('.select-plugin-wrap');
        
                    if (parent.hasClass('open')) {
                        parent.removeClass('open');
                    } else {
                        parent.addClass('open');
                    }
                });
        
                $('.select-plugin-wrap').on('click', '.select-plugin a', function(e) {
                    var parent = $(this).closest('.select-plugin-wrap');
                    parent.find('span.text-label').text(this.textContent);
                    parent.closest('.full-width').find('select.wpcf7-form-control').val(this.textContent);

                    e.preventDefault();
                });
            }
        },
        init: function() {
            var self = this, timer;

            $('.wpcf7-form-control-wrap.agreement').find('.wpcf7-list-item-label').each(function() {
                var label = $(this).text();
                var url = $('.voucher-content').data('policy');

                $(this).html(
                    label.toUpperCase()
                        .replace(/{BR}/g, Voucher.size.isMobile() ? '' : '<br />')
                        .replace(/{TERM}/g, '<a href="'+url+'" target="_blank"><strong>')
                        .replace(/{\/TERM}/g, '</strong></a>')
                );
            });

            $('body').on('click', '.grecaptcha-badge', function() {
                if (! Voucher.size.isDesktop()) {
                    if ($(this).hasClass('open')) {
                        $(this).css({
                            right: -($(this).width() - 70),
                        }).removeClass('open');
                    } else {
                        $(this).css({
                            right: '0px',
                        }).addClass('open');
                    }
                }
            });

            // Let's set the height of the gallery
            var $decorColumn = $('.col-form').find('.first-col');
            var $formColumn = $('.col-form').find('.second-col');
            var $gallery = $('.col-gallery');

            $gallery.find('> div').css({
                height: $formColumn.outerHeight(),
            });

            // Change the background of left form
            if (Voucher.size.isTabletMobile()) {
                var decorsmbg = $decorColumn.data('smSrc');

                if (decorsmbg.toString().trim() != '') {
                    $decorColumn.css({
                        'background-image': 'url('+decorsmbg+')',
                    });
                }
            }

            if (Voucher.is.ie()) {
                if (Voucher.size.isTabletMobile()) {
                    $decorColumn.css({
                        height: $(window).height()
                    });
                }
            }

            this.screen();
        },
        scale: function(el, scale, height, pos) {
            el.css({
                '-webkit-transform': 'scale(' + scale + ')',
                '-ms-transform': 'scale(' + scale + ')',
                'transform': 'scale(' + scale + ')',
                '-ms-transform-origin': 'center ' + (scale == 1 ? 'center' : (pos||'top')),
                '-webkit-transform-origin': 'center ' + (scale == 1 ? 'center' : (pos||'top')),
                'transform-origin': 'center ' + (scale == 1 ? 'center' : (pos||'top')),
            }).css('max-height', height);
        },
        size: {
            isDesktop: function() {
                return $(window).width() > 1024;
            },
            isTabletMobile: function() {
                return $(window).width() <= 1024;
            },
            isMobile: function() {
                return $(window).width() <= 767;
            }
        },
        is: {
            ie: function() {
                var ua = window.navigator.userAgent;
                var isIE = /MSIE|Trident/.test(ua);

                return isIE;
            }
        },
        screen: function() {
            var doc = $(document);
            var contentEl = $('.main-content');
            var heading = $('.title-header');
            var maxWidth  = contentEl.find('.col-form').width();
            var maxHeight = contentEl.find('.col-form').height();
	        var maxDHeight  = getDocHeight();
            var $window = $(window);
            var width = $window.width();
            var height = $window.height();
            var scale;

            width = width > 2100 ? width * 0.82 : width;

            var heightScale = height / maxHeight;
            var widthScale = width / maxWidth;

            var ua = window.navigator.userAgent;
            var isIE = /MSIE|Trident/.test(ua);

            if (isIE || width < 441) {
               return;
            }
            
            heading.css({'height': (height - contentEl.height())/2, 'min-height': (height - contentEl.height())/2});

            scale = Math.min(
                heightScale,        
                widthScale
            );

            if (height < 1100) {
                maxHeight = maxDHeight;
                scale = (height/maxHeight);
            }

        
            scale = scale - (Voucher.size.isDesktop() ? 0.05 : 0);
            scale = height < 424 ? 1 : scale;
            this.scale(contentEl, scale, 'auto', Voucher.size.isDesktop() ? 'center' : 'top');

            var _self = this;

            setTimeout(function() {
                var contentEl = $('.main-content');
                var h = getStyleProp(contentEl[0], "height");
                var remaining = height - h;
                var remainingHalf = (remaining/2);
                var scaleTime;

                scaleTime = setInterval( function() {
                    if (remainingHalf < 110 && Voucher.size.isDesktop()) {
                        scale = scale - 0.05;
                        _self.scale(contentEl, scale, 'auto', Voucher.size.isDesktop() ? 'center' : 'top');
                        
                        h = getStyleProp(contentEl[0], "height");
                        remaining = height - h;
                        remainingHalf = (remaining/2);
                    } else {
                        contentEl.css('max-height', Voucher.size.isTabletMobile() ? 'auto': h + 'px');
                        heading.css({'height': remainingHalf + 'px', 'min-height': remainingHalf + 'px'});
                        clearInterval(scaleTime);
                    }
                }, 50);
            }, 50);
        },
        displayGallery: function() {
           if (Voucher.size.isDesktop()) {
                var titleHeader = $('.title-header.on-header');
                var titleFooter = $('.title-header.on-footer');

                titleFooter.find('img').attr('src', titleFooter.find('img').data('gallery'));
                titleHeader.find('img').attr('src', titleHeader.find('img').data('gallery'));

                $('.col-form').removeClass('d-flex').addClass('d-none');
                $('.col-gallery').removeClass('d-none').addClass('d-flex');
           } else {
               var gallery = $('.gallery-view-mobile'),
                   thankyou = $('.thankyou-message');

               thankyou.addClass('d-none').removeClass('d-flex');
               gallery.removeClass('d-none').addClass('d-flex');
           }
        }
    };

    window.onload = function(e){
        Voucher.selectPlugin.init();
        Voucher.contact7FormEvents();
        Voucher.button.disable();
        Voucher.init();
    }
});
